import React, { useState, useEffect } from "react";
import i18n from "i18next";

import { fetchWrapper } from "../../helpers/fetchwrapper";
import { MmInch } from "../../helpers/mminch";

// Fluent UI Imports
import { baseUrl } from "../../helpers/constants";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Field,
  Radio,
  RadioGroup,
  Dropdown,
  Option,
  Label,
  Text,
} from "@fluentui/react-components";
import { CheckmarkRegular } from "@fluentui/react-icons";
import { ILuebOption } from "../../Models/ILuebOption";
import { StackItemShim, StackShim } from "@fluentui/react-migration-v8-v9";

interface IConfiguratorPanelProps {
  isDialogOpen: boolean;
  onDismiss: any;
  onSelectNorm: any;
  schraubfall: string;
}

function AerospaceDialog(props: IConfiguratorPanelProps) {
  const [normBolzen, setNormBolzen] = useState([]);
  const [normCollar, setNormCollar] = useState([]);

  const [filteredNormCollars, setFilteredNormCollars] = useState<ILuebOption[]>(
    [],
  );
  const [filteredNormCollarCodes, setFilteredNormCollarCodes] = useState<
    ILuebOption[]
  >([]);

  const [filteredNormBolzen, setFilteredNormBolzen] = useState<ILuebOption[]>(
    [],
  );
  const [filteredNormBolzenCodes, setFilteredNormBolzenCodes] = useState<
    ILuebOption[]
  >([]);

  useEffect(() => {
    if (props.isDialogOpen) {
      setNormSettings(defaultNormSettings);
    }
  }, [props.isDialogOpen]);

  const defaultNormSettings = {
    verschraubungsart:
      props.schraubfall == "holdndrive" ? "holdndrive" : "drehmoment",
    selectedCollarNorm: "",
    selectedCollarCode: "",
    selectedBolzenNorm: "",
    selectedBolzenCode: "",
    selectedCollar: { abreiss_Drehmoment: 0.0, schluesselweite: 0.0 },
    selectedBolzen: { schluesselweite: 0.0 },
    geometrie: "",
  };

  const [normSettings, setNormSettings] = useState(defaultNormSettings);

  const handleNormSettingsValuesChange = (name: string, val: any) => {
    setNormSettings((prevState) => ({
      ...prevState,
      [name]: val,
    }));
  };

  const verschraubungsartOptions: ILuebOption[] = [
    {
      key: "abreissCollar",
      text: i18n.t<string>("abreissCollar"),
      disabled: props.schraubfall == "mutter",
    },
    {
      key: "holdndrive",
      text: "Hold + Drive",
      disabled: props.schraubfall == "mutter",
    },
    {
      key: "drehmoment",
      text: i18n.t<string>("drehmoment"),
      disabled: props.schraubfall == "holdndrive",
    },
  ];

  useEffect(() => {
    handleNormSettingsValuesChange(
      "verschraubungsart",
      props.schraubfall == "holdndrive" ? "holdndrive" : "drehmoment",
    );
    getNormCollars();
  }, [props.schraubfall]);

  useEffect(() => {
    getNormBolzen();
    getNormCollar();
  }, []);

  const getNormBolzen = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/configurator/GetNormBolzen`)
      .then((data: any) => {
        setNormBolzen(data);
      });
  };

  const getNormCollar = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/configurator/GetNormCollar`)
      .then((data: any) => {
        setNormCollar(data);
      });
  };

  useEffect(() => {
    getNormCollars();
  }, [normCollar]);

  const getNormCollars = () => {
    handleNormSettingsValuesChange("selectedCollarNorm", "");
    const verschraubungsart =
      props.schraubfall == "holdndrive" ? "holdndrive" : "drehmoment";
    let options: ILuebOption[] = [];
    normCollar.forEach((element: any) => {
      let option: ILuebOption = { key: element.norm, text: element.norm };

      if (
        (normSettings.verschraubungsart == "drehmoment" &&
          element.drehmoment_Verschraubung?.toLowerCase() == "x") ||
        verschraubungsart == "holdndrive"
      ) {
        if (!options.some((e) => e.key === option.key)) {
          options.push(option);
        }
      }
    });
    setFilteredNormCollars(options);
  };

  useEffect(() => {
    handleNormSettingsValuesChange("selectedCollarCode", "");
    let options: ILuebOption[] = [];
    normCollar
      .filter((x: any) => x.norm == normSettings.selectedCollarNorm)
      .forEach((element: any) => {
        let option: ILuebOption = {
          data: element,
          key: element.code,
          text: element.code,
        };
        options.push(option);
      });
    setFilteredNormCollarCodes(options);
  }, [normSettings.selectedCollarNorm]);

  useEffect(() => {
    handleNormSettingsValuesChange("selectedBolzenNorm", "");
    let options: ILuebOption[] = [];
    normBolzen
      .filter((x: any) => x.code == normSettings.selectedCollarCode)
      .forEach((element: any) => {
        let option: ILuebOption = { key: element.norm, text: element.norm };
        options.push(option);
      });
    setFilteredNormBolzen(options);
  }, [normSettings.selectedCollarCode]);

  useEffect(() => {
    handleNormSettingsValuesChange("selectedBolzenCode", "");
    let options: ILuebOption[] = [];
    normBolzen
      .filter(
        (x: any) =>
          x.norm == normSettings.selectedBolzenNorm &&
          x.code == normSettings.selectedCollarCode,
      )
      .forEach((element: any) => {
        let option: ILuebOption = {
          data: element,
          key: element.code,
          text: element.code,
        };
        options.push(option);
      });
    setFilteredNormBolzenCodes(options);
  }, [normSettings.selectedBolzenNorm]);

  const isButtonDisabled = () => {
    if (normSettings.verschraubungsart == "holdndrive") {
      if (
        normSettings.selectedBolzenCode == "" ||
        normSettings.selectedBolzenNorm == "" ||
        normSettings.selectedCollarCode == "" ||
        normSettings.selectedCollarNorm == ""
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        normSettings.selectedCollarCode == "" ||
        normSettings.selectedCollarNorm == ""
      ) {
        return true;
      } else {
        return false;
      }
    }
  };

  return (
    <div>
      <Dialog open={props.isDialogOpen}>
        <DialogSurface>
          <DialogBody>
            <DialogTitle>{i18n.t<string>("aerospaceNorm")}</DialogTitle>
            <DialogContent>
              <div style={{ overflow: "hidden" }}>
                <Field label={i18n.t<string>("verschraubungsart")}>
                  <RadioGroup layout="horizontal">
                    {verschraubungsartOptions.map((item) => {
                      return (
                        <Radio
                          checked={
                            normSettings.verschraubungsart == item.key
                              ? true
                              : false
                          }
                          onChange={(ev, data) => {
                            handleNormSettingsValuesChange(
                              "verschraubungsart",
                              data.value,
                            );
                            getNormCollars();
                          }}
                          disabled={item.disabled}
                          value={typeof item.key == "string" ? item.key : ""}
                          label={
                            <div
                              style={{ color: item.disabled ? "" : "black" }}
                            >
                              {item.text}
                            </div>
                          }
                        />
                      );
                    })}
                  </RadioGroup>
                </Field>
                <Label>{i18n.t<string>("normVerbindungselement")}</Label>
                <StackShim horizontal tokens={{ childrenGap: 5 }} wrap={true}>
                  <StackItemShim
                    grow={1}
                    style={{ paddingLeft: 5, paddingRight: 5 }}
                  >
                    <Field label={i18n.t<string>("collar")}>
                      <Dropdown
                        selectedOptions={[normSettings.selectedCollarNorm]}
                        value={normSettings.selectedCollarNorm}
                        onOptionSelect={(ev, val) => {
                          handleNormSettingsValuesChange(
                            "selectedCollarNorm",
                            val.optionValue,
                          );
                        }}
                      >
                        {filteredNormCollars.map((item) => {
                          if (typeof item.key == "string") {
                            return (
                              <Option value={item.key}>{item.text}</Option>
                            );
                          }
                        })}
                      </Dropdown>
                    </Field>
                  </StackItemShim>
                  <StackItemShim
                    grow={1}
                    style={{ paddingLeft: 5, paddingRight: 5 }}
                  >
                    <Field label="Code">
                      <Dropdown
                        selectedOptions={[normSettings.selectedCollarCode]}
                        value={normSettings.selectedCollarCode}
                        onOptionSelect={(ev, data) => {
                          var selectedNormCollar = filteredNormCollarCodes.find(
                            (x) => x.key == data.optionValue,
                          )?.data;
                          if (
                            selectedNormCollar.abreiss_Collar?.toLowerCase() ==
                              "x" &&
                            normSettings.verschraubungsart == "holdndrive"
                          ) {
                            handleNormSettingsValuesChange(
                              "verschraubungsart",
                              "abreissCollar",
                            );
                          } else if (
                            (selectedNormCollar.abreiss_Collar == null ||
                              selectedNormCollar.abreiss_Collar == undefined ||
                              selectedNormCollar.abreiss_Collar == "") &&
                            normSettings.verschraubungsart == "abreissCollar"
                          ) {
                            handleNormSettingsValuesChange(
                              "verschraubungsart",
                              "holdndrive",
                            );
                          }
                          handleNormSettingsValuesChange(
                            "selectedCollarCode",
                            data.optionValue,
                          );
                          handleNormSettingsValuesChange(
                            "selectedCollar",
                            selectedNormCollar,
                          );
                        }}
                      >
                        {filteredNormCollarCodes.map((item) => {
                          if (typeof item.key == "string") {
                            return (
                              <Option value={item.key}>{item.text}</Option>
                            );
                          }
                        })}
                      </Dropdown>
                    </Field>
                  </StackItemShim>
                </StackShim>

                <StackShim horizontal tokens={{ childrenGap: 5 }} wrap={true}>
                  <StackItemShim
                    grow={1}
                    style={{ paddingLeft: 5, paddingRight: 5 }}
                  >
                    <Field label={i18n.t<string>("bolzen")}>
                      <Dropdown
                        disabled={
                          normSettings.verschraubungsart == "drehmoment" ||
                          normSettings.selectedCollarNorm == "" ||
                          normSettings.selectedCollarCode == ""
                        }
                        selectedOptions={[normSettings.selectedBolzenNorm]}
                        value={normSettings.selectedBolzenNorm}
                        onOptionSelect={(ev, val) => {
                          handleNormSettingsValuesChange(
                            "selectedBolzenNorm",
                            val.optionValue,
                          );
                        }}
                      >
                        {filteredNormBolzen.map((item) => {
                          if (typeof item.key == "string") {
                            return (
                              <Option value={item.key}>{item.text}</Option>
                            );
                          }
                        })}
                      </Dropdown>
                    </Field>
                  </StackItemShim>
                  <StackItemShim
                    grow={1}
                    style={{ paddingLeft: 5, paddingRight: 5 }}
                  >
                    <Field label="Code">
                      <Dropdown
                        disabled={
                          normSettings.verschraubungsart == "drehmoment" ||
                          normSettings.selectedCollarNorm == "" ||
                          normSettings.selectedCollarCode == "" ||
                          normSettings.selectedBolzenNorm == ""
                        }
                        selectedOptions={[normSettings.selectedBolzenCode]}
                        value={normSettings.selectedBolzenCode}
                        onOptionSelect={(ev, data) => {
                          var selectedNormCollar = filteredNormBolzenCodes.find(
                            (x) => x.key == data.optionValue,
                          )?.data;
                          handleNormSettingsValuesChange(
                            "selectedBolzenCode",
                            data.optionValue,
                          );
                          handleNormSettingsValuesChange(
                            "selectedBolzen",
                            selectedNormCollar,
                          );
                        }}
                      >
                        {filteredNormBolzenCodes.map((item) => {
                          if (typeof item.key == "string") {
                            return (
                              <Option value={item.key}>{item.text}</Option>
                            );
                          }
                        })}
                      </Dropdown>
                    </Field>
                  </StackItemShim>
                </StackShim>
                {normSettings.selectedCollar.schluesselweite != 0.0 && (
                  <StackShim tokens={{ childrenGap: 5 }}>
                    <Label style={{ marginTop: "20px", fontWeight: "bolder" }}>
                      {i18n.t<string>("swVerbindungselement")}
                    </Label>
                    <Text>
                      {"SW Collar [W]: " +
                        normSettings.selectedCollar.schluesselweite +
                        "mm " +
                        MmInch.toInch(
                          normSettings.selectedCollar.schluesselweite,
                        )}
                    </Text>
                    {normSettings.selectedBolzen.schluesselweite != 0.0 && (
                      <Text>
                        {"SW Bit [Y]: " +
                          normSettings.selectedBolzen.schluesselweite +
                          "mm " +
                          MmInch.toInch(
                            normSettings.selectedBolzen.schluesselweite,
                          )}
                      </Text>
                    )}
                  </StackShim>
                )}

                {normSettings.selectedCollar.schluesselweite != 0.0 && (
                  <StackShim>
                    <Label style={{ marginTop: "20px", fontWeight: "bolder" }}>
                      {i18n.t<string>("maxDrehmoment")}
                    </Label>
                    <Text>
                      {normSettings.selectedCollar.abreiss_Drehmoment +
                        " Nm / " +
                        (
                          normSettings.selectedCollar.abreiss_Drehmoment *
                          8.8507457676
                        ).toLocaleString(undefined, {
                          maximumFractionDigits: 3,
                        }) +
                        " in.lbs"}
                    </Text>
                  </StackShim>
                )}
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                style={{ marginLeft: "5px" }}
                appearance="primary"
                icon={<CheckmarkRegular />}
                disabled={isButtonDisabled()}
                onClick={() => props.onSelectNorm(normSettings)}
              >
                {i18n.t<string>("apply")}
              </Button>
              <Button
                onClick={() => {
                  props.onDismiss(true);
                }}
              >
                {i18n.t<string>("cancel")}
              </Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </div>
  );
}

export default AerospaceDialog;
